import { Box, Button, Collapse, IconButton, Typography } from "@mui/material";
import { useState } from "react";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CircleRoundedIcon from '@mui/icons-material/CircleRounded';
import * as styles from "../styles/Ratios.js"



  function RatiosCard({text, buttonText, dialogTittle, dialogText, dialogBold}) {
    const [open, setOpen] = useState(false);
  
    const handleOpen = () => {
      setOpen(true);
    };
    
    const handleClose = () => {
      setOpen(false);
    };
    
    return(
      <Box sx={styles.dialogContainerStyle}>
        <Box sx={styles.boxDialogStyle}>
            <Typography sx={styles.dialogTittleStyle}>{dialogTittle}</Typography>
            <Typography sx={styles.textCardStyle}>{text}</Typography>
        </Box>
        <Button onClick={handleOpen} sx={styles.buttonStyle} variant="contained"><Typography sx={styles.buttonTextStyle}>{buttonText}</Typography></Button>
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle sx={styles.dialogStyle}>{dialogTittle}</DialogTitle>
          <DialogContent>
            <Typography>
            <div dangerouslySetInnerHTML={{ __html: dialogText }} />
            <span style={{ fontWeight: 'bold' }}>{dialogBold}</span>
            </Typography>
          </DialogContent>
        </Dialog>
      </Box>
    )
  }

const Ratios = () => {

    const [textoActual, setTextoActual] = useState(1);
    const circle1 = {marginRight: '18px', color: textoActual === 1 ? '#1976D2' : '#C5C3C3'}
    const circle2 = {marginRight: '18px', color: textoActual === 2 ? '#1976D2' : '#C5C3C3'}
    const circle3 = {marginRight: '18px', color: textoActual === 3 ? '#1976D2' : '#C5C3C3'}

    const cambiarTexto = (nuevoTexto) => {
      setTextoActual(nuevoTexto);
    };



    return(
      <Box sx={styles.backgroundStyle}>
        <Box sx={styles.containerStyle}>
          <Box sx={styles.boxStyle}>
            <Collapse in={textoActual === 1} timeout={0}>
                <Box sx={styles.boxTextStyle}>
                  <Typography variant="h5" sx={styles.tittleText}>¿QUÉ SON?</Typography>
                  <Typography sx={styles.textStyle}>{styles.queSonText}</Typography>
                </Box>
            </Collapse>
            <Collapse in={textoActual === 2} timeout={0}>
                <Box sx={styles.boxTextStyle}>
                  <Typography variant="h5" sx={styles.tittleText}>¿PARA QUÉ SIRVEN?</Typography>
                  <Typography sx={styles.textStyle}>{styles.paraQueSirvenText}</Typography>
                </Box>
            </Collapse>
            <Collapse in={textoActual === 3} timeout={0}>
                <Box sx={styles.boxTextStyle}>
                  <Typography variant="h5" sx={styles.tittleText}>IMPORTANCIA</Typography>
                  <Typography sx={styles.textStyle}>{styles.importanciaText}</Typography>
                </Box>
            </Collapse>
            <Box sx={styles.boxCircle}>
              <IconButton
                onClick={() => cambiarTexto(1)}
              >
                <CircleRoundedIcon sx={circle1}/>
              </IconButton>
              <IconButton
                onClick={() => cambiarTexto(2)}
              >
                <CircleRoundedIcon sx={circle2}/>
              </IconButton>
              <IconButton
                onClick={() => cambiarTexto(3)}
              >
                <CircleRoundedIcon sx={circle3}/>
              </IconButton>
            </Box>
          </Box>
        </Box>
        
        <Typography variant="h3" sx={styles.ratiosTittle}>Principales Ratios Financieros</Typography>
        <Box sx={styles.ratiosBox}>
          <RatiosCard text={"Es un indicador que compara las ganancias de una empresa con su precio. Al dividir el valor de la acción por las ganancias de cada acción, se puede obtener el número de años que el inversor tardaría en recuperar su inversión. Por ejemplo, si una acción cotiza a $30 y la empresa gana $2 por acción, tendríamos un PER de 15 (30/2), el inversor tardaría 15 años en recuperar su inversión."} buttonText={"Capit de Mercado / Beneficios Netos"} dialogTittle={"Price to Earnings"} dialogText={"Capitalizacion de Mercado: Cuanto vale la empresa si uno comprara todas las acciones del mercado<br></br>Beneficios Netos: Cuanto gana la empresa luego de restar todos sus gastos de operaciones<br></br>"} dialogBold={"PER = Capitalización de Mercado / Beneficios Netos"}></RatiosCard>
          <RatiosCard text={"Definamos el enterprise value (EV) como el valor real de la empresa (Capitalización de mercado - Deudas + Efectivo Disponible). El EBITDA es el ingreso antes de descontar intereses pagados, impuestos, depreciación y amortización. Este indicador es útil para analizar empresas que tienen mucha deuda o que deprecian/amortizan muchos activos."} buttonText={"(Capit Mercado + Deuda) / EBITDA"} dialogTittle={"Enterp. Value to EBITDA"} dialogText={"Capitalizacion de Mercado: Cuanto vale la empresa si uno comprara todas las acciones del mercado<br></br>Deuda Neta: Es la deuda de la empresa una vez descontados el efectivo y equivalentes<br></br>EBITDA:Es la suma de los ingresos operativos mas las Depreciaciones y Amortizaciones<br></br>"} dialogBold={"EV/EBITDA = (Capitalización de Mercado - Deuda Neta) / EBITDA"}></RatiosCard>
          <RatiosCard text={"La métrica de Price to Book Value (P/BV) es la relación entre el valor de mercado de las acciones de una empresa (cotización) y su valor contable del patrimonio neto (Activos - Pasivos). Un P/BV menor a 1 nos dice que el patrimonio de la empresa es mayor que su cotización (estamos pagando menos de los activos que tiene), mientras que un P/BV mayor a 1 indica lo contrario."} buttonText={"Capit de Mercado / Patrimonio Neto"} dialogTittle={"Price to Book Value"} dialogText={"Capitalizacion de Mercado: Cuanto vale la empresa si uno comprara todas las acciones del mercado<br></br>Book Value: Es igual al Patrimonio Neto, Activos menos Pasivos<br></br>"} dialogBold={"P/BV = Capitalización de Mercado / Patrimonio Neto"}></RatiosCard>
          <RatiosCard text={"Es una métrica más avanzada, hila más fino en los ingresos de una empresa. El FCF o flujo de caja libre es cuánto dinero le entra a la empresa efectivamente por periodo (Resultado Neto + Depreciaciones / Amortizaciones - Gastos de Capital). Esto arroja un número más confiable de cuánto está ganando realmente la empresa, es una versión “mejorada” del PER ya que tiene en cuenta más factores."} buttonText={"Capit de Mercado / Flujo de Caja Libre"} dialogTittle={"Price to Free Cash Flow"} dialogText={"Capitalizacion de Mercado: Cuanto vale la empresa si uno comprara todas las acciones del mercado<br></br>Flujo de Caja Libre: Resultado Neto + Depreciaciones & Amortizaciones - Gastos de Capital<br></br>"} dialogBold={"P/FCF = Capitalización de Mercado / Flujo de Caja Libre"}></RatiosCard>
          <RatiosCard text={"Es un indicador que compara la capitalizacion de mercado de la empresa con sus ventas. Este indicador es util para evaluar empresas con margenes operativos muy ajustados y que, por ende, dependen de crecer sus ventas para que crezcan sus beneficios. Empresas como Amazon, se esfuerzan principalmente en hacer crecer sus ingresos, sin tener en cuenta los beneficios en el corto plazo."} buttonText={"Capit de Mercado / Ventas Totales"} dialogTittle={"Price to Sales"} dialogText={"Capitalizacion de Mercado: Cuanto vale la empresa si uno comprara todas las acciones del mercado<br></br>Ventas Totales: Incluye todas las ventas que la empresa consigue en el periodo fiscal<br></br>"} dialogBold={"P/Sales = Capitalizacion de Mercado / Ventas Totales"}></RatiosCard>
          <RatiosCard text={"Si el P/FCF es una version mejorada del PER, esta lo es aun mas ya que en vez de utilizar la capitalizacion de mercado utiliza el enterprise value, lo que permite ponderar la cantidad de deuda o el sobrante de efectivo de la empresa al evaluarla. Es un ratio que pondera, al mismo tiempo, la situacion financiera de la empresa y sus beneficios."} buttonText={"(Capit Mercado + Deuda) / F. Caja Libre"} dialogTittle={"PER (Price to Earnings)"} dialogText={"Capitalizacion de Mercado: Cuanto vale la empresa si uno comprara todas las acciones del mercado<br></br>Deuda Neta: Es la deuda de la empresa una vez descontados el efectivo y equivalentes<br></br>Flujo de Caja Libre: Resultado Neto + Depreciaciones & Amortizaciones - Gastos de Capital<br></br>"} dialogBold={"EV/FCF = (Capitalización de Mercado - Deuda Neta) / Flujo de Caja Libre"}></RatiosCard>
        </Box>
      </Box>  
    );
}




export default Ratios;

